import { Box, Image } from '@leagueplatform/genesis-core';
import * as React from 'react';

const ASPECT_RATIO_REGEX = /^\d+\s*\/\s*\d+$/;

type IdCardProps = {
  source: string;
  description?: string;
  aspectRatio?: string;
  type: 'url' | 'base64';
  hasBorder?: boolean;
};

const formatHandleAspectRatio = (aspectRatio: string | undefined) => {
  if (ASPECT_RATIO_REGEX.test(aspectRatio ?? '')) {
    return aspectRatio;
  }

  return aspectRatio?.replace(':', '/');
};

const handleBase64Source = (source: string, type: string) => {
  if (type === 'base64' && !source.startsWith('data:image/png;base64,')) {
    return `data:image/png;base64,${source}`;
  }

  return source;
};

export function IdCard({
  source: imageSource,
  description,
  aspectRatio: aspectRatioString,
  type,
  hasBorder,
}: IdCardProps) {
  let source = imageSource;
  const aspectRatio = React.useMemo(
    () => formatHandleAspectRatio(aspectRatioString),
    [aspectRatioString],
  );

  if (type === 'base64') {
    const base64Source = handleBase64Source(source, type);
    source = base64Source;
  }

  return (
    <Box
      className="id-card"
      css={{
        display: 'inline-flex',
      }}
    >
      <Image
        src={source}
        alt={description}
        css={{
          aspectRatio,
          maxWidth: '100%',
          display: 'block',
          overflow: hasBorder ? 'hidden' : undefined,
          borderStyle: hasBorder ? 'solid' : undefined,
          borderColor: hasBorder ? '$onSurfaceBorderSubdued' : undefined,
          borderRadius: hasBorder ? '$extraLarge' : undefined,
          borderWidth: hasBorder ? '$card' : undefined,
        }}
      />
    </Box>
  );
}
